/**
 *
 * @param {string} name
 * @param {string} [avatar]
 */
export function renderAgent(name, avatar) {
  const agentArea = /** @type {HTMLElement | null} */ (
    document.getElementById('chat-agent')
  )

  if (!agentArea) {
    console.warn('renderAgent: agent display element not found, skipping')
    return
  }

  const agentName = /** @type {HTMLElement | null} */ (
    agentArea.querySelector('.agent .agent-name')
  )
  if (!agentName) {
    console.warn('renderAgent: agent name element not found, skipping')
    return
  }
  agentName.innerHTML = name

  const avatarImg = /** @type {HTMLImageElement | null} */ (
    agentArea.querySelector('.agent-img img')
  )
  if (!avatarImg) {
    console.warn('renderAgent: avatar image element not found, skipping')
    return
  }
  avatarImg.src = avatar
    ? avatar
    : 'https://cdn.files-text.com/api/accounts/avatars/a2805e9c-4b8d-4312-8820-a5eaeb56e6f3/02d92fdf-5e7c-4c53-a4bc-0a91b5e75b1f/e484aa79-089c-42bd-bb48-47dde4efae75.jpeg'

  // Show the avatar image and hide the default SVG
  avatarImg.style.display = 'block'
  const defaultIcon = /** @type {HTMLElement | null} */ (
    agentArea.querySelector('#default-agent-icon')
  )
  if (defaultIcon) {
    defaultIcon.style.display = 'none'
  }

  // Show the online agent info and hide offline message
  const onlineInfo = /** @type {HTMLElement | null} */ (
    agentArea.querySelector('#agent-info-online')
  )
  const offlineInfo = /** @type {HTMLElement | null} */ (
    agentArea.querySelector('#agent-info-offline')
  )
  if (onlineInfo) {
    onlineInfo.style.display = 'block'
  }
  if (offlineInfo) {
    offlineInfo.style.display = 'none'
  }
}
